import { GlobalStorageObject } from "./type/global-storage-object.type";

export class GlobalStorageOutDTO {
  updatedAt!: Date;
  values!: GlobalStorageObject;
}
